/* @flow */
import { getterFromKeyPath, alphabetize } from 'trustar/utils';
import { createSelector } from 'reselect';
import { Map, OrderedMap } from 'immutable';
import isString from 'lodash.isstring';
import escapeRegExp from 'lodash.escaperegexp';
import { _EnclaveTemplate as TemplateRecord } from './types.js';

import { credentialsTypes, accessTypes, labels, subscriptionMethods, getDefaultEntityTypes } from 'modules/miscellaneous/getters.js';
import type { EntityType } from 'modules/miscellaneous/types.js';

export const loading = getterFromKeyPath(['templates', 'loading']);
export const displayOptions = getterFromKeyPath(['templates', 'options']);

const _templatesMap = getterFromKeyPath(['templates', 'templates']);

export const template = (id: number) => {
  return createSelector(
    templatesMap,
    (templates: OrderedMap<any, any>) => templates.get(id),
  );
};

export const templatesMap = createSelector(
  [ _templatesMap, displayOptions ],
  (templates: OrderedMap<any, any>, options: OrderedMap<any, any>) => {
    return templates
    .filter(template => {
      const query = options.get('query');
      const regex = new RegExp(escapeRegExp(query), 'i');

      // Test all top-level string values
      return template
        .toSeq()
        .valueSeq()
        .filter(isString)
        .some(x => x.search(regex) > -1);
    })
    .sort(alphabetize);
  }
);

// whether enclaves from this template can be directly managed
const canManageEnclave = (template, subscriptionMethods) => {
  const subscriptionMethod = subscriptionMethods.get(
    template.get('subscriptionMethod')
  );
  return subscriptionMethod.get('canManageEnclave');
};


// the templates that can be manually assigned to enclaves through admin flow
export const assignableTemplates = createSelector(
  [ templatesMap, subscriptionMethods ],
  (templatesMap, subscriptionMethods) =>
    templatesMap.filter(t => canManageEnclave(t, subscriptionMethods))
);

// Determine initial form values for template add/edit form
export const getInitialFormValues = (template: ?Map<any, any>) => createSelector(
  accessTypes,
  credentialsTypes,
  labels,
  subscriptionMethods,
  getDefaultEntityTypes,
  (
    accessTypes: Map<string, any>,
    credentialsTypes: Map<string, any>,
    labels: Map<string, any>,
    subscriptionMethods: Map<string, any>,
    defaultEntityTypes: Map<string, EntityType>
  ) => {
    return !template ?
      TemplateRecord({})
      : TemplateRecord(
        template
          .update('credentialsType', x => credentialsTypes.get(x))
          .update('label', x => labels.get(x))
          .update('subscriptionMethod', x => subscriptionMethods.get(x))
      );
  }
);




// WEBPACK FOOTER //
// ./src/app/modules/templates/getters.js